/**
 * Stub for react-native-reanimated on web builds.
 * Reanimated is native-only — its .js files contain JSX that breaks Vite/Rollup.
 * Web animations use CSS transitions or react-spring instead.
 */

// Shared value stub
export function useSharedValue(initial: any) { return { value: initial }; }
export function useAnimatedStyle(cb: () => any) { return cb(); }
export function useDerivedValue(cb: () => any) { return { value: cb() }; }
export function useAnimatedScrollHandler() { return {}; }
export function withTiming(value: any) { return value; }
export function withSpring(value: any) { return value; }
export function withDelay(_: number, value: any) { return value; }
export function withSequence(...values: any[]) { return values[values.length - 1]; }
export function withRepeat(value: any) { return value; }
export function runOnJS(fn: Function) { return fn; }
export function runOnUI(fn: Function) { return fn; }
export function cancelAnimation() {}
export function interpolate(value: number, input: number[], output: number[]) { return value; }
export function Extrapolation() {}
Extrapolation.CLAMP = 'clamp';

// Layout animations
export const FadeIn = { duration: () => FadeIn };
export const FadeOut = { duration: () => FadeOut };
export const SlideInRight = { duration: () => SlideInRight };
export const SlideOutLeft = { duration: () => SlideOutLeft };
export const Layout = { duration: () => Layout };
export const LayoutAnimation = { configureNext: () => {} };

// Animated component factory
const createAnimatedComponent = (component: any) => component;
const Animated = {
  View: 'div',
  Text: 'span',
  ScrollView: 'div',
  Image: 'img',
  createAnimatedComponent,
};

export default Animated;
